module.exports = __webpack_public_path__ + "resources/1ac94711e8b6b5158b4d3c4e74d13013.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/herotransformed.png
// module id = 211
// module chunks = 0